import { useTheme } from 'styled-components';

export const DocumentsIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 4C1 2.89543 1.89543 2 3 2H9.58579C9.851 2 10.1054 2.10536 10.2929 2.29289L11.7071 3.70711C11.8946 3.89464 12.149 4 12.4142 4H17C18.1046 4 19 4.89543 19 6V16C19 17.1046 18.1046 18 17 18H3C1.89543 18 1 17.1046 1 16V4Z"
        stroke={theme.iceBlue}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M5 10H15" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 13H11" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
